<template>
  <div class="candidate-list-page">
    <section class="list-shell">
      <div class="page-head">
        <div>
          <h1>我的委员推荐申请</h1>
          <p>同一账号对同一个专委会只能提交一次申请，可同时申请其他专委会。</p>
        </div>
        <el-button type="primary" @click="createApplication">新增申请</el-button>
      </div>

      <el-table v-loading="loading" :data="tableData" border class="application-table">
        <el-table-column prop="committee" label="专委会" min-width="180" show-overflow-tooltip />
        <el-table-column prop="serial_no" label="编号" min-width="170" show-overflow-tooltip />
        <el-table-column prop="name" label="姓名" width="100" />
        <el-table-column prop="id_number" label="身份证号" min-width="180" show-overflow-tooltip />
        <el-table-column prop="member_no" label="会员证号" min-width="170" show-overflow-tooltip />
        <el-table-column prop="company" label="工作单位" min-width="180" show-overflow-tooltip />
        <el-table-column prop="status" label="状态" width="110">
          <template #default="scope">
            <el-tag :type="getStatusTag(scope.row.status)">{{ getStatusLabel(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="submit_time" label="提交时间" min-width="170" show-overflow-tooltip />
        <el-table-column label="操作" width="120" fixed="right">
          <template #default="scope">
            <el-button
              v-if="Number(scope.row.status) !== 2"
              type="primary"
              link
              @click="editApplication(scope.row)"
            >
              修改
            </el-button>
            <span v-else class="muted">不可修改</span>
            <el-button type="success" link @click="printApplication(scope.row)">打印</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-empty v-if="!loading && tableData.length === 0" description="暂无委员推荐申请">
        <el-button type="primary" @click="createApplication">去申请</el-button>
      </el-empty>

      <el-pagination
        v-if="total > 0"
        v-model:currentPage="currentPage"
        :total="total"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        background
        class="pagination"
        @current-change="pageCurrentChange"
      />
    </section>
  </div>
</template>

<script>
import candidateRecommend from '@/api/candidateRecommend'

export default {
  name: 'CandidateRecommendList',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const res = await candidateRecommend.getList({
          page: this.currentPage,
          pagesize: this.pageSize
        })
        const data = res && res.data ? res.data : {}
        this.tableData = data.data || []
        this.total = Number(data.total || 0)
        this.currentPage = Number(data.current_page || this.currentPage)
      } finally {
        this.loading = false
      }
    },
    pageCurrentChange(page) {
      this.currentPage = page
      this.getList()
    },
    createApplication() {
      this.$router.push('/user/candidate-recommend/apply')
    },
    editApplication(row) {
      this.$router.push({
        path: '/user/candidate-recommend/apply',
        query: { id: row.id }
      })
    },
    printApplication(row) {
      this.$router.push({
        path: '/user/candidate-recommend/detail',
        query: { id: row.id }
      })
    },
    getStatusLabel(status) {
      const map = { 0: '草稿', 1: '已提交', 2: '审核通过', 3: '审核驳回' }
      return map[Number(status)] || '-'
    },
    getStatusTag(status) {
      const map = { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger' }
      return map[Number(status)] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.candidate-list-page {
  min-height: 100vh;
  padding: 28px 16px 48px;
  background: #f5f7fa;
}

.list-shell {
  max-width: 1040px;
  margin: 0 auto;
  padding: 24px;
  background: #fff;
  box-shadow: 0 12px 36px rgba(31, 45, 61, 0.08);
}

.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;

  h1 {
    margin: 0 0 6px;
    font-size: 24px;
    line-height: 1.3;
    color: #111827;
  }

  p {
    margin: 0;
    color: #6b7280;
    line-height: 1.6;
  }
}

.application-table {
  width: 100%;
}

.muted {
  color: #909399;
  font-size: 13px;
}

.pagination {
  margin-top: 24px;
  justify-content: center;
}

@media (max-width: 768px) {
  .candidate-list-page {
    padding: 12px;
    background: #fff;
  }

  .list-shell {
    padding: 0;
    box-shadow: none;
  }

  .page-head {
    display: block;

    h1 {
      font-size: 20px;
    }

    .el-button {
      width: 100%;
      margin-top: 12px;
    }
  }
}
</style>
